import axios from '@/api/config';

const specialExerciseQuestion = {
  getSpecialExerciseQuestionById(data) {
    return axios.get(`${process.env.BASE_URL}/specialExerciseQuestion/getSpecialExerciseQuestionById/` + data, {});
  },
  getSpecialExerciseQuestionDetail(data) {
    return axios.get(`${process.env.BASE_URL}/specialExerciseQuestion/getSpecialExerciseQuestionDetail`, {params: data});
  },
  getSpecialExerciseQuestion(data) {
    return axios.get(`${process.env.BASE_URL}/specialExerciseQuestion/getSpecialExerciseQuestion`, {params: data});
  },
  getSpecialExerciseQuestionList(data) {
    return axios.get(`${process.env.BASE_URL}/specialExerciseQuestion/getSpecialExerciseQuestionList`, {params: data});
  },
  getSpecialExerciseQuestionTree(data) {
    return axios.get(`${process.env.BASE_URL}/specialExerciseQuestion/getSpecialExerciseQuestionTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/specialExerciseQuestion/pageList`, data);
  },
  addSpecialExerciseQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/specialExerciseQuestion/addSpecialExerciseQuestion`, data);
  },
  updateSpecialExerciseQuestion(data) {
    return axios.put(`${process.env.BASE_URL}/specialExerciseQuestion/updateSpecialExerciseQuestion`, data);
  },
  deleteSpecialExerciseQuestion(data) {
    return axios.delete(`${process.env.BASE_URL}/specialExerciseQuestion/deleteSpecialExerciseQuestion`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/specialExerciseQuestion/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/specialExerciseQuestion/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/specialExerciseQuestion/active`, data);
  },
}

export default specialExerciseQuestion;



// WEBPACK FOOTER //
// ./src/api/specialExerciseQuestion.js